var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"mt-5"},[_c('v-card-title',[_vm._v("Welcome to Training "+_vm._s(_vm.username_show))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }